export default {"src":"/_next/static/media/ObesityMetabolicDisorders.68e5bf18.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};